import * as types from '../../mutation-types.js';
import http from '@service/http';
import util from '@common/utils/util';

/**
 * 购物车STORE
 */


const CART_GOOD_NUM = 'CART_GOOD_NUM'


export default {
  state: {
    cartGoodsNum: 0,
  },
  actions: {
    //13.9.获取购物车商品数量
    getCartGoodsNum({ commit }) {
      return http.post({
        fn: 'mallsale.cartHandler.getCartGoodsNum',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          commit(CART_GOOD_NUM, result.target.target);
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject(util.getResultErrMsg(result));
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*14.1.从购物车结算*/
    getOrderSettleMsgFromCart({ commit }, data) {
      return http.post({
        fn: 'mallsale.settleHandler.getOrderSettleMsgFromCart',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*14.3.提交订单*/
    createOrder({ commit }, data) {
      return http.post({
        fn: 'mallsale.settleHandler.createOrder',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || (result.target && result.target.message))) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    // 15.6.提交订单（带订单号）
    createOrderWithOrder({ commit }, data) {
      return http.post({
        fn: 'mallsale.settleHandler.createOrderWithOrder',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || (result.target && result.target.message))) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    //15.7. 获取待支付订单信息
    getSettleResult({ commit }, data) {
      return http.post({
        fn: 'mallsale.settleHandler.getSettleResult',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || (result.target && result.target.message))) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*8.1.获取微信js配置config*/
    getWxJsSdkConfig({ commit }, data) {
      return http.post({
        fn: 'mallsale.wxHandler.getWxJsSdkConfig',
        param: data
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*8.2.微信公众号支付*/
    doWxMpPay({ commit }, data) {
      return http.post({
        fn: 'mallsale.payHandler.doWxMpPay',
        param: data
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*8.2.微信公众号支付*/
    doWxH5Pay({ commit }, data) {
      return http.post({
        fn: 'mallsale.payHandler.doWxH5Pay',
        param: data
      }).then(result => {
        if (result && result.success) {
          return Promise.resolve(result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    /*8.2.微信公众号支付*/
    doUnionWapConsumePay({ commit }, data) {
      return http.post({
        fn: 'mallsale.payHandler.doUnionWapConsumePay',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },

    // 13.2.获取发票类型列表
    listInvoiceType({ commit }) {
      return http.post({
        fn: 'mallsale.invoiceHandler.listInvoiceType',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    // 13.3.获取发票内容列表
    listInvoiceContent({ commit }) {
      return http.post({
        fn: 'mallsale.invoiceHandler.listInvoiceContent',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    // 13.4.获取会员单位发票列表
    listMemInvoiceMsg({ commit }) {
      return http.post({
        fn: 'mallsale.invoiceHandler.listMemInvoiceMsg',
        param: []
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    // 13.5.保存会员单位发票列表
    saveMemInvoice({ commit }, data) {
      return http.post({
        fn: 'mallsale.invoiceHandler.saveMemInvoice',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    // 13.6.删除会员单位发票
    removeMemInvoice({ commit }, data) {
      return http.post({
        fn: 'mallsale.invoiceHandler.removeMemInvoice',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
    //21.5.获取订单支付结果
    getOrderPayResult({ commit }, orderNo) {
      return http.post({
        fn: 'mallsale.payHandler.getOrderPayResult',
        param: orderNo
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },


  },
  mutations: {
    [CART_GOOD_NUM](state, data) {
      state.cartGoodsNum = data;
    },
  },
  getters: {
    cartGoodsNum: state => {
      return state.cartGoodsNum;
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cart/index.js